import { HttpErrorResponse } from '@angular/common/http';

// Error code shown on the customer unexpected-error screen (#10627). Shared so the
// global ErrorHandler and the NgRx effects' generic error fallback can't drift apart.
export const UNEXPECTED_ERROR_CODE = '206';

// Reads the backend-assigned reference off a failed HTTP response, or generates a
// client-side one in the same format when there's no backend response to read from
// (see #10627 — customer unexpected-error screen).
export function resolveIncidentReference(error: any): string {
  if (error instanceof HttpErrorResponse) {
    const fromHeader = error.headers?.get('X-Incident-Reference');
    if (fromHeader) {
      return fromHeader;
    }
  }
  return generateClientIncidentReference();
}

export function generateClientIncidentReference(): string {
  const now = new Date();
  const pad = (n: number, len = 2) => String(n).padStart(len, '0');
  const ms = pad(now.getUTCMilliseconds(), 3);
  const timestamp = [
    `${now.getUTCFullYear()}-${pad(now.getUTCMonth() + 1)}-${pad(now.getUTCDate())}`,
    `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}.${ms}`,
  ].join('-');
  const id = Math.random().toString(36).slice(2, 14).padEnd(12, '0');
  return `${timestamp}-${id}`;
}
